module.exports = __webpack_public_path__ + "img/about-terjangkau.25ed5a6e.png";